import Comment from './BaseComment';

export * from './BaseComment';
export default Comment;
